var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.049 11.098c-.01-1.722.785-3.019 2.392-3.975-.898-1.262-2.258-1.956-4.05-2.09-1.697-.132-3.554.969-4.234.969-.718 0-2.361-.924-3.654-.924C2.835 5.118 0 7.163 0 11.322q0 1.846.688 3.807c.612 1.72 2.822 5.938 5.127 5.87 1.205-.028 2.057-.838 3.625-.838 1.522 0 2.31.838 3.654.838 2.326-.033 4.324-3.866 4.906-5.593-3.118-1.441-2.951-4.22-2.951-4.308M12.343 3.4C13.647 1.88 13.53.497 13.49 0c-1.154.066-2.488.77-3.247 1.636-.837.928-1.329 2.077-1.223 3.372 1.246.093 2.384-.536 3.321-1.608"
  })));
};
export default SvgApple;